import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';

export const getChallanType = createAsyncThunk('challanTypeSlice/getChallanType', async () => {
    try {
        let response = await axios.get('/challan-type', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getChallanTypeOption = createAsyncThunk('challanTypeSlice/getChallanTypeOption', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/challan-type?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createChallanType = createAsyncThunk('challanTypeSlice/createChallanType', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/challan-type', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Kyc doc created successfully.');
        dispatch(getChallanType());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateChallanType = createAsyncThunk('challanTypeSlice/updateChallanType', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/challan-type/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Kyc doc updated successfully.');
        dispatch(getChallanType());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteChallanType = createAsyncThunk('challanTypeSlice/deleteChallanType', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/challan-type/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Kyc doc deleted successfully');
        dispatch(getChallanType());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateChallanTypeStatus = createAsyncThunk('challanTypeSlice/updateChallanTypeStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/challan-type/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getChallanType());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const challanTypeSlice = createSlice({
    name: 'challanTypeSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getChallanType.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getChallanTypeOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default challanTypeSlice.reducer;
